import styled from "styled-components";

export const TruckMapContainerStyle = styled.div`
    width: 100%;
    height: calc(100% - 70px);
    display: flex;
`;
